module.exports = __webpack_public_path__ + "static/media/us.924be0c1.svg";